import update from 'immutability-helper';
import { createReducer } from '../modules/helpers';

import { ActionTypes } from '../constants/index';

const initState = {
  needsUpdate: false,
};

export const clientReducer = createReducer(initState, {

  [ActionTypes.CLIENT_APP_UPDATE_REQUEST](state) {
    // console.log('client reducer got hit');
    return update(state, {
      needsUpdate: { $set: true },
    });
  },

});



// WEBPACK FOOTER //
// ./scripts/reducers/client.js